import React from "react";
import { Box, Typography } from "@mui/material";
import CustomModal from "../CustomModal/CustomModal";
import Button from "../CustomButtons/Button";
import { DateRange } from "@mui/icons-material";

import modalStyle from "../../assets/jss/material-dashboard-react/components/messageModalStyle";

export default function MessageModal(props) {
    const { open, handleClose, title, text, buttonLabel, createdAt, customButton, customButtonLabel, customOnClick } = props;

    return (
        <CustomModal open={open} onClose={handleClose}>
            <Box sx={modalStyle.root}>

                <Box sx={modalStyle.titleContainer}>
                    <Typography sx={modalStyle.titleText}>{title}</Typography>
                </Box>

                <Box sx={modalStyle.bodyContainer}>
                    {createdAt && (
                        <Box sx={modalStyle.bodyTime}>
                            <DateRange />
                            <Typography>{createdAt}</Typography>
                        </Box>
                    )}

                    <Typography sx={modalStyle.bodyText}>{text}</Typography>
                </Box>


                <Box sx={modalStyle.footerContainer}>

                    {customButton && (
                        <Button type={"button"} size={"sm"} color="danger" sx={modalStyle.button} onClick={customOnClick}>
                            {customButtonLabel}
                        </Button>
                    )}

                    <Button type={"button"} size={"sm"} color="info" sx={modalStyle.button} onClick={handleClose}>
                        {buttonLabel}
                    </Button>

                </Box>
            </Box>
        </CustomModal>
    );
}
